import axios from "axios";
import cookie from "react-cookies";
import { HOST_URL, APP_ID } from "../../config/constans";
import { returnValue} from "../../config/supporters";
export const GET_ADVANCED_ORDERS = "settings/GET_ADVANCED_ORDERS";
const initialState = {
  returnData: [],
  isFetching: true,
  isError: null,
  isStatus: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ADVANCED_ORDERS:
      return {
        ...state,
        returnData: action.returnData,
        isStatus: action.isStatus,
        isFetching: false
      };

    default:
      return state;
  }
}
export function getadvancedOrders(search_key , search_value , a_from_date , a_to_date , order_source) {
  let appId = returnValue(cookie.load(APP_ID));
  let API_URL = cookie.load(HOST_URL) + "api/reports/order_history";
  var searchStirng1 = "";
    var searchStirng2 = "";
	  var searchStirng3 = "";
  if( (search_key !== "" && typeof search_key !== "undefined" ) && (search_value !== "" && typeof search_value !== "undefined" )) {
	   searchStirng3  =  "&"+search_key + "=" + search_value;
  }
  
    if( ( a_from_date !== ""  && typeof a_from_date !== "undefined" )  && (a_to_date !== "" && typeof a_to_date !== "undefined" )) {
	  searchStirng1=  "&from_date=" + a_from_date + "&to_date="+a_to_date;
  }
 
   if( typeof order_source !== "undefined" &&  order_source !== "") {
	 searchStirng2 =  "&order_source=" + order_source;
  }
 
  return function(dispatch) {
    axios
      .get(
        `${API_URL}/?app_id=` +
          appId + "&order_type=Advanced&except_availability=yes"+searchStirng1 + searchStirng2 + searchStirng3
      )
      .then(response => {
        dispatch({
          type: GET_ADVANCED_ORDERS,
          returnData: response.data.result_set,
          isStatus: response.data.status,
          isFetching: false
        });
      })
      .catch(error => {
        console.log(error);
      });
  };
}
